import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { MILESTONE_DEFINITIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const milestonePresentationSettingsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case MILESTONE_DEFINITIONS_ACTION_TYPE.GET_MILESTONE_PRESENTATION_SETTINGS:
        return payload;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default milestonePresentationSettingsReducer;
